import includes from 'lodash/includes';

import type { DetectorParams } from '../types';
import { referralAndTextRoutes, searchEngines } from '../const';

/**
 * Detect the brand-search channel
 */
export const isBrandSearchChannelFn = ({
  utmSource,
  firstUrl,
  firstReferer,
  referrerMedium,
}: DetectorParams): boolean => {
  if (utmSource) {
    return false;
  }

  if (referralAndTextRoutes.some((v) => includes(firstUrl?.pathname, v))) {
    return false;
  }

  return (
    (firstUrl?.href?.endsWith('getjerry.com/') ||
      firstUrl?.href?.endsWith('getjerry.com/about') ||
      [
        'getjerry.com/faq',
        'getjerry.com/how-it-works',
        'getjerry.com/contact',
        'getjerry.com/reviews',
        'getjerry.com/terms-of-use',
        'getjerry.com/privacy-policy',
        'getjerry.com/licenses',
        'getjerry.com/signup',
        'getjerry.com/team',
        'getjerry.com/investor',
      ].some((v) => includes(firstUrl?.href, v))) &&
    (referrerMedium === 'search' || searchEngines.some((v) => includes(firstReferer, v)))
  );
};
